import React from 'react';
import PropTypes from 'prop-types';
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight';

import Link from '~hooks/link';
import styles from './module-title.module.scss';

const ModuleTitle = ({ module, viewMoreIcon = <FaAngleRight />, pageContext = null }) => {
  const getTitle = () => {
    if (module.module_title_tag === 'h2') return <h2>{module.module_title}</h2>;
    if (module.module_title_tag === 'h3') return <h3>{module.module_title}</h3>;
    if (module.module_title_tag === 'h4') return <h4>{module.module_title}</h4>;
    if (module.module_title_tag === 'h5') return <h5>{module.module_title}</h5>;
    if (module.module_title_tag === 'h6') return <h6>{module.module_title}</h6>;
    return <span className={styles.noTag}>{module.module_title}</span>;
  };
  // if (
  //   module.name === 'content' &&
  //   (module.module_title === 'table' ||
  //     module.module_title === 'table-1' ||
  //     module.module_title === 'table-2' ||
  //     (module.style && module.style.includes('table')))
  // ) {
  //   return null;
  // }

  const type = pageContext && pageContext?.page?.type;

  return (
    <>
      {(module.module_title || module.link_label) && (
        <div
          className={`${styles.moduleTitle} ${styles[type]}  ${
            module?.style && styles[module.style]
          }`}
        >
          {module.module_title && getTitle(module)}
          {module.link_label && (
            <Link to={module.link_value} className={`${styles.viewMore} module-title-gtm`}>
              {module.link_label}
              {viewMoreIcon}
            </Link>
          )}
        </div>
      )}
    </>
  );
};

ModuleTitle.propTypes = {
  module: PropTypes.shape({
    module_title: PropTypes.string,
    module_title_tag: PropTypes.string,
    link_label: PropTypes.string,
    link_value: PropTypes.string,
    name: PropTypes.string,
    style: PropTypes.string,
  }),
  viewMoreIcon: PropTypes.element,
  pageContext: PropTypes.shape({}),
};

export default ModuleTitle;
